import { render, staticRenderFns } from "./DocDownload.vue?vue&type=template&id=2975c0cb&scoped=true&"
import script from "./DocDownload.vue?vue&type=script&lang=js&"
export * from "./DocDownload.vue?vue&type=script&lang=js&"
import style0 from "./DocDownload.vue?vue&type=style&index=0&id=2975c0cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975c0cb",
  null
  
)

export default component.exports